import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/resources/template.tsx");
